var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1640_9150)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 235.5,
    fill: "white",
    stroke: "white",
    strokeWidth: 29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356 295.992C356 363.921 315.243 406.683 250.5 406.683C185.757 406.683 145 363.921 145 295.992C145 223.097 220.63 124.689 243.826 96.2247C244.651 95.2134 245.675 94.4015 246.828 93.8449C247.981 93.2882 249.235 93 250.504 93C251.773 93 253.027 93.2882 254.179 93.8449C255.332 94.4015 256.356 95.2134 257.182 96.2247C280.37 124.689 356 223.097 356 295.992Z",
    fill: "#FEF4E8",
    stroke: "black",
    strokeWidth: 10.7175,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.969 302.141C314.969 316.819 309.411 330.897 299.519 341.276C289.626 351.655 276.209 357.486 262.219 357.486",
    fill: "#FEF4E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.969 302.141C314.969 316.819 309.411 330.897 299.519 341.276C289.626 351.655 276.209 357.486 262.219 357.486",
    stroke: "#4045A1",
    strokeWidth: 19.0533,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1640_9150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    rx: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.ddde8d5b6bae6d0fe991e9f3cf958a55.svg";
export { ForwardRef as ReactComponent };